import { defineStore } from 'pinia'
import { randomId } from '@composables/utils/guid.js'

export const useRequest = defineStore('request', {
  state: () => ({
    requestId: null
  }),

  getters: {
    hasRequestId: (state) => state.requestId != null
  },

  actions: {
    stopRequestTransaction() {
      this.$reset()
    },
    startRequestTransaction() {
      this.requestId = randomId()
    }
  }
})
